import { plugin as deepVisibility } from './deep-visibility';

export const plugins = {
  [deepVisibility.name]: deepVisibility,
};
